import React, { useMemo } from 'react';
import { Box, Button, Grid } from '@mui/material';
import PropTypes from 'prop-types';

import useSurveySettings from 'src/hooks/useSurveySettings.ts';
import { useUserContext } from 'src/components/app/context/UserContext';
import { usePlanActionContext } from 'src/components/planAction/PlanActionContext';

import { styles } from './index.styles';

export const KPI_GRID_TEST_ID = 'kpi-grid';

const getFavLabel = (fav, minRespondentAmount) => {
  // TODO translate NegSel
  if (typeof fav !== 'number') return `n<${minRespondentAmount} / NegSel`;

  return `${fav} %`;
};

const KPIGrid = ({ onSelect, editable = false, errors = null }) => {
  const { planActionStatus } = usePlanActionContext();
  const { currentSurvey } = useUserContext();
  const { minRespondentAmount } = useSurveySettings();
  const kpis = useMemo(
    () =>
      planActionStatus && planActionStatus.value && planActionStatus.value.kpis
        ? planActionStatus.value.kpis.filter(
            ({ year }) => year === currentSurvey?.year,
          )
        : [],
    [planActionStatus],
  );

  return (
    <Box sx={styles.wrapper(!!(errors && errors.kpi))}>
      <Grid
        container
        spacing={1}
        sx={styles.grid}
        data-test-id={KPI_GRID_TEST_ID}
      >
        {kpis.map((kpi) => (
          <Grid item xs={4} key={kpi.id}>
            <Button
              variant="ctaTertiary"
              sx={styles.button}
              disabled={!editable}
              onClick={() => onSelect(kpi.id)}
            >
              {kpi.label}
              <br />
              {`- ${getFavLabel(kpi.fav, minRespondentAmount)} -`}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

KPIGrid.propTypes = {
  onSelect: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  errors: PropTypes.shape({
    kpi: PropTypes.string,
  }),
};

export default KPIGrid;
